import Styled from 'styled-components';

export const FixedColorsIcon = Styled.div.attrs({className: 'fixed-colors'})`
	display: inline;
	cursor: ${props => (props.onClick ? 'pointer' : 'default')};
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
